/* FIDNO size guide — opens the product's size chart in a native <dialog>,
   converts cm / in on the fly and highlights the size already picked in the
   variant picker. Markup: snippets/fidno-size-guide.liquid */

if (!customElements.get('fidno-size-guide')) {
  customElements.define(
    'fidno-size-guide',
    class FidnoSizeGuide extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.fidno-size-guide__trigger');
        this.baseUnit = this.dataset.unit || 'cm';
        if (!this.dialog || !this.trigger) return;

        this.trigger.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-fidno-size-close]').forEach((button) =>
          button.addEventListener('click', () => this.dialog.close())
        );
        // a click on the backdrop lands on the <dialog> itself, not the panel
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('fidno-size-guide-open');
          this.trigger.focus();
        });
        this.querySelectorAll('[data-fidno-unit]').forEach((button) =>
          button.addEventListener('click', () => this.setUnit(button.dataset.fidnoUnit))
        );
      }

      open() {
        this.highlightSelectedSize();
        document.body.classList.add('fidno-size-guide-open');
        this.dialog.showModal();
      }

      setUnit(unit) {
        this.querySelectorAll('[data-fidno-unit]').forEach((button) =>
          button.setAttribute('aria-pressed', String(button.dataset.fidnoUnit === unit))
        );
        this.querySelectorAll('[data-fidno-measure]').forEach((cell) => {
          const value = parseFloat(cell.dataset.fidnoMeasure);
          if (Number.isNaN(value)) return;
          if (unit === this.baseUnit) {
            cell.textContent = cell.dataset.fidnoMeasure;
          } else {
            const converted = unit === 'in' ? value / 2.54 : value * 2.54;
            cell.textContent = (Math.round(converted * 10) / 10).toString();
          }
        });
      }

      highlightSelectedSize() {
        const scope = this.closest('section, .product') || document;
        const checked = scope.querySelector(
          'input[data-option-name="Size"]:checked, input[data-option-name="size"]:checked'
        );
        const selected = checked ? checked.value : null;
        this.querySelectorAll('[data-fidno-size-row]').forEach((row) => {
          row.classList.toggle('is-selected', row.dataset.fidnoSizeRow === selected);
        });
      }
    }
  );
}
